export enum APPLICATION_STATUS {
  TO_VALIDATE = "to-validate",
  VALIDATED_BY_CC = "validated-by-cc",
  REFUSED_BY_CC = "refused-by-cc",
  ACCEPTED_BY_CUSTOMER = "accepted-by-customer",
  REFUSED_BY_CUSTOMER = "refused-by-customer",
  EXPIRED = "expired",
}
